import { Link } from 'react-router-dom';

export default function NotFound() {
    return (
        <div className='min-h-screen flex items-center justify-center bg-slate-100 px-4'>
            <div className='max-w-md w-full rounded-3xl bg-white/80 backdrop-blur border border-slate-200 shadow-xl p-8 text-center space-y-6'>

                <div className='mx-auto w-36 h-36 rounded-full bg-docpgrPurple/10 flex items-center justify-center '>
                    <div className='flex flex-col'>
                        <img src='/assets/invoco_logo_long_purple_transparentbg.webp' alt='invoco logo'></img>
                        <span className='text-3xl font-bold text-docpgrPurple'>403</span>
                    </div>
                </div>

                <div className='space-y-2'>
                    <h1 className='text-xl font-bold text-slate-800'>
                        access denied
                    </h1>
                    <p className='text-sm text-slate-600'>
                        you don't have permission to view this page
                    </p>
                </div>

                <div className='space-y-3'>
                    <Link to='/dashboard' className='block w-full rounded-lg bg-docpgrPurple px-4 py-2 text-sm font-semibold text-white hover:shadow-docpgr-purple-glow transition'>
                        back to dashboard
                    </Link>
                </div>

                <p className='text-xs text-slate-400'>
                    if you beleive this is an error, please contact support
                </p>
                <p>
                    <a href='mailto:support@docpgr.com' className='text-xs text-docpgrPurple hover:underline'>
                        support@docpgr.com
                    </a>
                </p>

            </div>
        </div>
    )
}